import React, { forwardRef, useEffect, useState, useRef } from "react";
import { Form, Modal } from "antd";
import parse from "html-react-parser";

import { Editor } from "@tinymce/tinymce-react";
import ENV from "../../consts/config";
import FileChonky from "../chonky/index";
import ReactDOM from "react-dom";
import { useSelector, useDispatch } from "react-redux";

const ProductDescriptions = forwardRef((props, ref) => {
  const { user: authUser } = useSelector((x) => x.auth);

  const shortDescriptionRef = useRef(null);
  const descriptionRef = useRef(null);
  const ingredientRef = useRef(null);
  const useProductRef = useRef(null);

  let description = props.productItem ? props?.productItem?.description || "" : "";

  if (description !== "") {
    description = parse(description)
    description = description.replaceAll(
      `${ENV.IMAGE_VARIABLE}`,
      `${ENV.CDN_URL}`
    );
  }
  const shortDescription = props.productItem
    ? parse(props?.productItem?.shortDescription || "")
    : "";

  const ingredients = props.productItem
    ? parse(props?.productItem?.ingredients || "")
    : "";
  const useProduct = props.productItem
    ? parse(props?.productItem?.use || "")
    : "";

  useEffect(() => {
    props.onInit({
      shortDescription: shortDescriptionRef,
      description: descriptionRef,
      ingredient: ingredientRef,
      use: useProductRef,
    });
  }, [shortDescriptionRef, descriptionRef, ingredientRef, useProductRef]);

  const showBox = (callback, value, meta) => {
    const ModalFile = (props) => {
      const [show, setShow] = useState(true);
      const [image, setImage] = useState();
      useEffect(() => {}, []);
      const onSelected = (data) => {
        setImage(data);
      };
      const onAction = () => {
        document.querySelector(".tox .tox-dialog-wrap").style.display = "";
        ReactDOM.unmountComponentAtNode(props.modal);
      };
      return (
        <>
          <Modal
            title=""
            visible={show}
            width={1300}
            style={{ top: 20 }}

            onOk={() => {
              setShow(false);
              props.callback(`${ENV.CDN_URL}${image}`);
              onAction();
            }}
            okButtonProps={{
              disabled: !image,
            }}
            onCancel={() => {
              setShow(false);
              onAction();
            }}
            destroyOnClose={true}
          >
            {authUser ? (
              <div style={{ padding: "15px" }}>
                <style>
                  {`.ant-modal-wrap{
            z-index: 1300
          } .ant-image-preview-wrap{z-index: 1301}`}
                </style>
                <FileChonky onSelected={onSelected} />
                <br />
              </div>
            ) : null}
          </Modal>
        </>
      );
    };
    const modal = document.createElement("span");
    document.querySelector(".tox .tox-dialog-wrap").style.display = "none";
    ReactDOM.render(<ModalFile modal={modal} callback={callback} />, modal);
  };

  return (
    <>
      <Form
         labelCol={{
          span: 2,
        }}
        layout="horizontal"
        size="large"
      >
        <Form.Item label="Mô tả ngắn" tooltip="Mô tả rút gọn của sản phẩm">
          <Editor
            tinymceScriptSrc={
              process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
            }
            initialValue={shortDescription.toString()}
            onInit={(evt, editor) => (shortDescriptionRef.current = editor)}
            init={{
              height: 300,
              menubar: false,
              language: "vi",
              plugins: ["advlist", "lists", "link", "wordcount"],
              toolbar:
                "undo redo | blocks | " +
                "bold italic forecolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
            // onEditorChange={onChange}
          />
        </Form.Item>
        <Form.Item label="Mô tả đầy đủ" tooltip="Mô đầy đủ của sản phẩm">
          <div>
            <Editor
              tinymceScriptSrc={
                process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
              }

              initialValue={description.toString()}
              onInit={(evt, editor) => (descriptionRef.current = editor)}
              init={{
                image_advtab: false,
                image_title: true,
                file_picker_callback: showBox,
                file_picker_types: "image",
                height: 600,
                menubar: true,
                language: "vi",
                plugins: [
                  "advlist",
                  "autolink",
                  "lists",
                  "link",
                  "image",
                  "charmap",
                  "preview",
                  "anchor",
                  "searchreplace",
                  "visualblocks",
                  "code",
                  "fullscreen",
                  "insertdatetime",
                  "media",
                  "table",
                  "help",
                  "wordcount",
                ],

                toolbar:
                  "undo redo  | link image | blocks | " +
                  "bold italic forecolor | alignleft aligncenter " +
                  "alignright alignjustify | bullist numlist outdent indent | " +
                  "removeformat | help",
                content_style:
                  "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
              }}
            />
          </div>
        </Form.Item>

        <Form.Item
          label="Công dụng"
          tooltip="Công dụng sản phẩm hiển thị ở trang chi tiết"
        >
          <Editor
            tinymceScriptSrc={
              process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
            }
            initialValue={useProduct.toString()}
            onInit={(evt, editor) => (useProductRef.current = editor)}
            init={{
              height: 300,
              menubar: false,
              language: "vi",
              plugins: ["advlist", "lists", "link", "wordcount"],
              toolbar:
                "undo redo | blocks | " +
                "bold italic forecolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
          />
        </Form.Item>

        <Form.Item
          label="Thành phần"
          tooltip="Thành phần sản phẩm hiển thị ở trang chi tiết"
        >
          <Editor
            tinymceScriptSrc={
              process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
            }
            initialValue={ingredients.toString()}
            onInit={(evt, editor) => (ingredientRef.current = editor)}
            init={{
              height: 300,
              menubar: false,
              language: "vi",
              plugins: ["advlist", "lists", "link", "wordcount"],
              toolbar:
                "undo redo | blocks | " +
                "bold italic forecolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
          />
        </Form.Item>
      </Form>
    </>
  );
});

export default ProductDescriptions;
